import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { InputAdornment, MenuItem, Typography } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";

function CustomAutocomplete({
  value,
  onValueChange,
  textProps = {},
  options = [],
  autoCompleteProps = {},
  showEndAdornment = true,
  noOptionsText = "No options",
  getOptionLabel = (option) => option,
  isOptionEqualToValue = (option, value) => option === value,
  sx = {},
}) {
  return (
    <Autocomplete
      {...autoCompleteProps}
      fullWidth
      value={value}
      onChange={(event, newValue) => onValueChange(newValue)}
      options={options}
      noOptionsText={noOptionsText}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textProps}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: showEndAdornment && (
                <InputAdornment position="end">
                  <IoIosArrowDown />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
      renderOption={(props, option) => {
        return (
          <MenuItem {...props} key={props.id}>
            <Typography variant="body1">{getOptionLabel(option)}</Typography>
          </MenuItem>
        );
      }}
      sx={{ ...sx }}
    />
  );
}

export default CustomAutocomplete;
